import React from "react";
import {connect} from "react-redux";
import {googleLogin} from "../../actions/Auth";
import "../../styles/Shared/Shared.css";
import "../../styles/Expense_Tracker/Styles_Login.css";

const Login = (props) => {
    return (
        <div className="login-container">
            <div className="login-main">
                <p className="login-title">Login to Muong14</p>
                <button className="login-google-btn" onClick={() => {
                    props.googleLogin();
                }}>Login With Google</button>
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
   googleLogin: () => dispatch(googleLogin())
});

// We need to use the connect function in this js file because the google login will return the auth state to the index.js
// Index.js contains the Provider and firebase is collecting the status from googleLogin function in this file
// Therefore we need to use the connect in order to pass the authentication function into the button
// And also provide the Login.js with the right to modify the auth state of the current user

export default connect(undefined, mapDispatchToProps)(Login);